import React from "react";

export function ProjectCardWidget({ project, configuration }) {
  let url = project.url;
  const getStatusClasses = (status) => {
    if (status === "sin-definir") {
      return "text-bg-secondary";
    } else if (status === "en-marcha") {
      return "text-bg-success";
    } else if (status === "finalizado") {
      return "text-bg-warning";
    } else {
      return "text-bg-danger";
    }
  };

  return (
    <a className="card card-primary text-decoration-none mt-3 mb-3 card-hover shadow-sm" href={url} >
      <div className="row g-0 min-height-card-primary">
        {/* Col Txt */}
        <div className="col-md-6 d-flex flex-column p-2">
          <div className="card-body d-flex flex-column align-items-start gap-2">
            <div className="d-flex flex-column align-items-start justify-content-start gap-1 w-100">
              {/* Status Pill  */}
              <span className={`badge rounded-pill ${getStatusClasses( project.status )}`} >
                {project.status_label}
              </span>
            </div>
            {/* Card Title */}
            <h4 className="card-title h6">{project.title}</h4>
            {/* Card Footer */}
            <div className="mt-auto">
              {/* Participants */}
              <span className="d-flex align-items-center gap-1 fs-7 py-1" title={configuration.translations.participantes} >
                <i className="fa-solid fa-user"></i>
                {project.participants} / {project.capacity}
              </span>
              {/* Participa Btn */}
              <div className="mt-auto fw-bold text-uppercase fs-7">
                <span>{configuration.translations.takePart}</span>
                <i className="fa-solid fa-arrow-right ms-1"></i>
              </div>
            </div>
          </div>
        </div>
        {/* Col Img & Badges */}
        <div className="col-12 col-md-6 position-relative">
          {/* Main Img  */}
          <div className="ratio ratio-16x9 h-100">
            <img
              src={project.list_image}
              alt={project.title}
              width="200"
              height="200"
              loading="lazy"
              className="w-100 h-100 object-fit-cover rounded-card-primary-img img-fluid"
            />
          </div>
        </div>
      </div>
    </a>
  );
}
